export const posFunctions = {
  data() {
    return {
      redeemPoints: 0,
      tempRedeemPoints: 0
    }
  },

  methods: {
    // set usable redeem points
    setRedeemPoints(item) {
      const subTotal = this.invoice__products.reduce((acc, product) => {
        const total = product.sub_total - (product.discountType === 1 ? (product.discount * this.promotional_sub_total(product)) / 100 : Number(product.discount))
        acc = acc + (total >= 0 ? total : 0)
        return acc
      }, 0)

      if (this.convertRedeemPointToDollar(item) > subTotal) {
        item = this.convertRedeemDollarToPoints(subTotal)
      }

      this.redeemPoints = this.tempRedeemPoints = Math.ceil(Math.max(0, Math.abs(item)))

      // calculate redeem modal
      this.setMaxRedeemPointsPerProduct()
    },

    // calculate maximum applicable redeem points per product
    setMaxRedeemPointsPerProduct() {
      this.redeemPoints = 0
      // calculate redeem modal
      this.invoice__products.forEach((item, index) => {
        const tempSubTotal = item.sub_total - (item.discountType === 1 ? (item.discount * this.promotional_sub_total(item)) / 100 : Number(item.discount))

        if (this.tempRedeemPoints >= 1 && this.redeemPointSettings && tempSubTotal > 0) {
          const tempRedeemPoints = (tempSubTotal * this.redeemPointSettings.redeem_points) / this.redeemPointSettings.redeem_dollar || 0
          const applicablePoints = this.tempRedeemPoints < tempRedeemPoints ? this.tempRedeemPoints : tempRedeemPoints

          // remaing redeem points
          this.tempRedeemPoints -= applicablePoints
          this.redeemPoints += Math.ceil(applicablePoints)

          // apply redeem points
          this.invoice__products[index].item_redeem_points = Math.ceil(applicablePoints)
        } else {
          this.invoice__products[index].item_redeem_points = 0
        }
      })

      this.$nextTick(() => {
        // calculate discount
        this.calculate_product_tax()
      })
    },

    // convert redeem points to redeem dollar
    convertRedeemPointToDollar(redeemPoints) {
      if (redeemPoints && this.redeemPointSettings) {
        return (redeemPoints * this.redeemPointSettings.redeem_dollar) / this.redeemPointSettings.redeem_points
      }
      return 0
    },

    // convert redeem dollar to redeem points
    convertRedeemDollarToPoints(dollar) {
      if (dollar && this.redeemPointSettings) {
        return (dollar * this.redeemPointSettings.redeem_points) / this.redeemPointSettings.redeem_dollar
      }

      return 0
    }
  },

  computed: {
    totalRedeemAmount() {
      const totalRedeemPoint = this.redeemPoints
      return this.convertRedeemPointToDollar(totalRedeemPoint)
    }
  },

  watch: {
    reedemType() {
      if (this.reedemType === 'all') {
        this.tempRedeemPoints = this.customerDetail.reward_points
      }
      this.setMaxRedeemPointsPerProduct()
    }
  }
}
